<template>
    <div class="text-center">
        <v-dialog
            v-model="isOpen"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            width="50%"
            @click:outside="close"
            @keydown.esc="close"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{ $t('userEditing') }}
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model.trim="name"
                                    :rules="[rules.required]"
                                    :placeholder="$t('firstName')"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model.trim="email"
                                    :rules="[rules.required]"
                                    placeholder="Email"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model.trim="phone"
                                    :rules="[rules.required]"
                                    :placeholder="$t('phoneNumber')"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model.trim="comment"
                                    :rules="[rules.maxLength(this.commentMaxLength)]"
                                    :counter="this.commentMaxLength"
                                    :placeholder="$t('comment')"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="close"
                    >
                        {{ $t('close') }}
                    </v-btn>
                    <v-btn
                        color="teal"
                        text
                        :disabled="!isValid"
                        @click="save"
                    >
                        {{ $t('save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { MixinTextFieldValidators } from '../../../mixins';

    export default {
        name: 'EditModal',
        mixins: [MixinTextFieldValidators],
        model: {
            prop: 'isOpen',
            event: 'close'
        },
        props: {
            isOpen: {
                required: true,
                type: Boolean,
            },
            user: {
                required: false,
                type: Object,
                default: () => ({}),
            }
        },
        data() {
            return {
                id: '',
                name: '',
                email: '',
                phone: '',
                comment: '',
                commentMaxLength: 255,
            }
        },
        computed: {
            isValid() {
                return [
                    this.validators.required(this.name),
                    this.validators.required(this.email),
                    this.validators.required(this.phone),
                    this.validators.maxLength(this.commentMaxLength)(this.comment)
                ].every(Boolean);
            },
        },
        methods: {
            close() {
                this.$emit('close', false);
                this.clear();
            },
            save() {
                if (!this.isValid) {
                    return false;
                }

                const data = {
                    id: this.id,
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    comment: this.comment,
                }

                this.$emit('save', data);
                this.close();
                this.clear();
            },
            clear() {
                this.id = this.name = this.email = this.phone = this.comment = '';
            }
        },
        watch: {
            user(value) {
                if (value) {
                    const { id, name, email, phone, comment } = value;

                    this.id = id;
                    this.name = name;
                    this.email = email;
                    this.phone = phone;
                    this.comment = comment;
                } else {
                    this.clear();
                }
            }
        },
    }
</script>

<style scoped>

</style>
